export enum Activity {
  MONITOR_TRANSPORTS = 'MONITOR_TRANSPORTS',
  MANAGE_TRANSPORT_DOCUMENTS = 'MANAGE_TRANSPORT_DOCUMENTS',
  MANAGE_TRANSPORT_ORDERS = 'MANAGE_TRANSPORT_ORDERS',
  PLAN_TRANSPORTS = 'PLAN_TRANSPORTS',
}
